var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramSmallLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7518 12.3594C11.6244 12.3594 12.3318 11.6519 12.3318 10.7793C12.3318 9.90669 11.6244 9.19922 10.7518 9.19922C9.87922 9.19922 9.17188 9.90669 9.17188 10.7793C9.17188 11.6519 9.87922 12.3594 10.7518 12.3594Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7717 6.78906H8.73169C7.64169 6.78906 6.76172 7.66903 6.76172 8.75903V12.7991C6.76172 13.8891 7.64169 14.769 8.73169 14.769H12.7717C13.8617 14.769 14.7417 13.8891 14.7417 12.7991V8.75903C14.7417 7.66903 13.8617 6.78906 12.7717 6.78906ZM10.7517 13.3691C9.32171 13.3691 8.16174 12.2091 8.16174 10.7791C8.16174 9.34905 9.32171 8.18896 10.7517 8.18896C12.1817 8.18896 13.3417 9.34905 13.3417 10.7791C13.3417 12.2091 12.1817 13.3691 10.7517 13.3691ZM13.3517 8.8291C13.0017 8.8291 12.7117 8.54896 12.7117 8.18896C12.7117 7.82896 12.9917 7.54907 13.3517 7.54907C13.7017 7.54907 13.9917 7.82896 13.9917 8.18896C13.9917 8.53896 13.7017 8.8291 13.3517 8.8291Z",
    fill: "#0F0F0F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 0.779297C5.23 0.779297 0.75 5.2593 0.75 10.7793C0.75 16.2993 5.23 20.7793 10.75 20.7793C16.27 20.7793 20.75 16.2993 20.75 10.7793C20.75 5.2593 16.27 0.779297 10.75 0.779297ZM15.75 12.7993C15.75 14.4393 14.42 15.7793 12.77 15.7793H8.72998C7.08998 15.7793 5.75 14.4493 5.75 12.7993V8.75928C5.75 7.11928 7.07998 5.7793 8.72998 5.7793H12.77C14.41 5.7793 15.75 7.10928 15.75 8.75928V12.7993Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramSmallLogo);
export default __webpack_public_path__ + "static/media/instagramSmallLogo.0343ff371d495faae916a7d4f5ace14a.svg";
export { ForwardRef as ReactComponent };